export default __webpack_public_path__ + "media/images/Task-36b505aed34995a5c88661eec94cb95d.png";